module.exports = __webpack_public_path__ + "img/cg-btn.e75ee1b8.webp";